/** Тосты и диалог подтверждения — глобально, вызываются из любого места. */
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ApiError } from '@/api/http';

export interface Toast {
  id: number;
  tone: 'success' | 'danger' | 'info' | 'warning';
  title: string;
  text?: string;
}

export interface ConfirmRequest {
  title: string;
  text?: string;
  confirmLabel?: string;
  danger?: boolean;
  resolve: (ok: boolean) => void;
}

let seq = 0;

export const useUi = defineStore('ui', () => {
  const toasts = ref<Toast[]>([]);
  const confirmState = ref<ConfirmRequest | null>(null);

  function toast(t: Omit<Toast, 'id'>, ttl = 4000) {
    const id = ++seq;
    toasts.value.push({ ...t, id });
    window.setTimeout(() => dismiss(id), ttl);
  }
  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }
  const success = (title: string, text?: string) => toast({ tone: 'success', title, text });
  function error(e: unknown, fallback = 'Не получилось') {
    const text = e instanceof ApiError || e instanceof Error ? e.message : String(e);
    toast({ tone: 'danger', title: fallback, text }, 6000);
  }

  function confirm(req: Omit<ConfirmRequest, 'resolve'>): Promise<boolean> {
    return new Promise((resolve) => {
      confirmState.value = { ...req, resolve };
    });
  }
  function answer(ok: boolean) {
    confirmState.value?.resolve(ok);
    confirmState.value = null;
  }

  return { toasts, toast, success, error, dismiss, confirmState, confirm, answer };
});
